// components
import { WidgetItem, WidgetItemInfo } from "../index"
// assets
import { PenIcon, UserSquareIcon } from "@assets/icons"
import { Link } from "react-router-dom"

export const ProfileDetailsWidgetMobile = ({ widgetData, fullName }) => {
  // Define the attributes we want to display in order
  const attributesToDisplay = [
    "email",
    "contact",
    "location",
    "Reference Number",
    "createdAt",
    "address",
    "eye",
    "disorder",
  ]

  return widgetData ? (
    <WidgetItem
      title="PROFILE DETAILS"
      titleIcon={
        <UserSquareIcon className="h-6 w-6 text-[var(--text-theme)]" />
      }
      subHeading={fullName}
      editComponent={
        <Link
          to="/contact"
          className="px-4 py-1 border border-[#D6EBFF] rounded-2xl mr-4"
          id="contact-admin-to-edit"
        >
          <PenIcon className="h-[1rem] w-[1rem] text-[--primary-blue]" />
        </Link>
      }
      content={
        <div className="grid grid-cols-2 gap-4 pt-4 ">
          {attributesToDisplay.map((key) => {
            const value = widgetData[key]

            if (key === "disorder") {
              return (
                <WidgetItemInfo
                  key={key}
                  label={key}
                  data={value}
                  isDisorder={true}
                  allDisorders={widgetData.allDisorders}
                  className="col-span-1"
                />
              )
            }

            return (
              <WidgetItemInfo
                key={key}
                label={key}
                data={value || ""}
                className="col-span-1"
              />
            )
          })}
        </div>
      }
    />
  ) : null
}
